__turbopack_context__.v({
  "buttons-content": "Popover-module-scss-module__5WWpvq__buttons-content" + " " + "Popover-module-scss-module__5WWpvq__popover-content-base",
  "overlay": "Popover-module-scss-module__5WWpvq__overlay",
  "popover": "Popover-module-scss-module__5WWpvq__popover",
  "popover-content": "Popover-module-scss-module__5WWpvq__popover-content" + " " + "Popover-module-scss-module__5WWpvq__popover-content-base",
  "popover-content-base": "Popover-module-scss-module__5WWpvq__popover-content-base",
  "scale-up-popover-center": "Popover-module-scss-module__5WWpvq__scale-up-popover-center",
  "scrollable": "Popover-module-scss-module__5WWpvq__scrollable",
  "sticky-bottom": "Popover-module-scss-module__5WWpvq__sticky-bottom",
  "title-close": "Popover-module-scss-module__5WWpvq__title-close",
  "title-container": "Popover-module-scss-module__5WWpvq__title-container",
  "title-content": "Popover-module-scss-module__5WWpvq__title-content" + " " + "Popover-module-scss-module__5WWpvq__popover-content-base",
  "title-text": "Popover-module-scss-module__5WWpvq__title-text",
});
